import React from 'react';

import logoLight from 'assets/images/mbp.svg';

export default function Footer() {
  return (
    <footer className="subfooter">
      <div className="container">
        <div className="subfooter-row">
          <div className="subfooter-logo">
            <strong className="logo">
              <a href="#top">
                <img src={logoLight} alt="logo" />
              </a>
            </strong>
          </div>
          <div className="subfooter-text size-sm">
            <h3 className="subfooter-title">
              Improve efficiency, reduce efforts and minimize risk
            </h3>
            with an intuitive tech platform built for the contractor workforce.
          </div>
        </div>
      </div>
    </footer>
  );
}
